import { CrossIcon } from '@grupoboticario/flora-react-icons';
import { ButtonAlt } from 'ui/components/primitives';
import { Close } from './Modal.components.styles';
import type { CloseProps } from './Modal.components.d';

const CloseBase = ({ onClick, sizeButton, sizeIcon, ...rest }: CloseProps) => {
  const size = sizeIcon === 'small' ? 12 : 20;
  return (
    <Close>
      <ButtonAlt onClick={onClick} size={sizeButton} {...rest}>
        <CrossIcon size={size} />
      </ButtonAlt>
    </Close>
  );
};

export default CloseBase;
